/**
 * Performance PDP: per subscription interval quantity (min 1 / 3 / 6), syncs to form quantity,
 * updates line totals on the selected card, hides duplicate buy-button qty while subscription is selected.
 */
(function () {
  var SUB_QTY_FORM_CLASS = "skio-flat-subscription-qty-active";

  function moneyFormatter() {
    return new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: window.Shopify && window.Shopify.currency && window.Shopify.currency.active
        ? window.Shopify.currency.active
        : "USD",
    });
  }

  function getFormQtyInput(form) {
    if (!form) return null;
    return form.querySelector('input[name="quantity"]');
  }

  function updateMinusState(qtyInput) {
    var wrap = qtyInput.closest(".quantity-wrapper");
    if (!wrap) return;
    var min = Number(qtyInput.dataset.minQty);
    if (!Number.isFinite(min) || min < 1) min = 1;
    var v = parseInt(String(qtyInput.value), 10);
    if (!Number.isFinite(v)) v = min;
    var btn = wrap.querySelector('[data-mode="minus"]');
    if (!btn) return;
    var atMin = v <= min;
    btn.disabled = atMin;
    btn.setAttribute("aria-disabled", atMin ? "true" : "false");
    btn.classList.toggle("skio-performance-flat-qty--disabled", atMin);
  }

  function updateShipmentDesc(card, qty) {
    var el = card.querySelector(".skio-performance-plan-card__desc-text");
    if (!el) return;
    var bucket = el.getAttribute("data-shipment-bucket") || "1";
    var sing = el.dataset.unitSingular || "tube";
    var plur = el.dataset.unitPlural || "tubes";
    var u = qty === 1 ? sing : plur;
    var q = qty;
    if (bucket === "6") {
      el.textContent =
        q +
        " " +
        u +
        " delivered every 180 days. Pause or cancel anytime.";
    } else if (bucket === "3") {
      el.textContent =
        q + " " + u + " delivered every 90 days. Pause or cancel anytime.";
    } else {
      el.textContent =
        q + " " + u + " delivered monthly. Pause or cancel anytime.";
    }
  }

  function applyQtyToCardPrice(fieldset, qtyInput) {
    if (!fieldset || !qtyInput) return;
    var card = qtyInput.closest(".skio-performance-flat-plan-card");
    if (!card) return;
    var priceEl = card.querySelector("[skio-subscription-price]");
    if (!priceEl) return;
    var unit = Number(priceEl.dataset.unitPriceCents);
    if (!Number.isFinite(unit)) return;
    var q = parseInt(String(qtyInput.value), 10);
    if (!Number.isFinite(q) || q < 1) q = 1;
    var min = Number(qtyInput.dataset.minQty);
    if (Number.isFinite(min) && q < min) q = min;

    var mf = moneyFormatter();
    var suffixEl = priceEl.querySelector(".skio-subscription-price-suffix");
    var suffixText = suffixEl ? suffixEl.textContent : "";

    priceEl.textContent = "";
    priceEl.appendChild(
      document.createTextNode(mf.format((unit * q) / 100))
    );
    if (suffixText) {
      var span = document.createElement("span");
      span.className = "skio-subscription-price-suffix";
      span.textContent = suffixText;
      priceEl.appendChild(span);
    }

    var compareEl = card.querySelector(".skio-performance-plan-card__compare");
    if (compareEl) {
      var cUnit = Number(compareEl.dataset.compareUnitCents);
      if (Number.isFinite(cUnit) && cUnit > 0) {
        compareEl.textContent = mf.format((cUnit * q) / 100);
        compareEl.style.display = "";
      }
    }

    updateShipmentDesc(card, q);
  }

  function resetInactiveCardQtyInputs(fieldset, checkedRadio) {
    fieldset.querySelectorAll(".skio-performance-flat-plan-card").forEach(function (card) {
      var radio = card.querySelector('.skio-performance-flat-plan-card__native[skio-selling-plan-group]');
      if (!radio || radio === checkedRadio) return;
      var inp = card.querySelector(".skio-performance-flat-qty-input");
      if (!inp) return;
      var min = Number(inp.dataset.minQty);
      if (!Number.isFinite(min) || min < 1) min = 1;
      inp.value = String(min);
      updateMinusState(inp);
      updateShipmentDesc(card, min);
    });
  }

  function subscriptionChecked(fieldset) {
    return !!fieldset.querySelector(
      'input.skio-group-input[skio-selling-plan-group]:checked'
    );
  }

  function syncFormSubscriptionMode(fieldset) {
    var form = fieldset.closest("form");
    if (!form) return;
    var subOn = subscriptionChecked(fieldset);
    form.classList.toggle(SUB_QTY_FORM_CLASS, subOn);
    return form;
  }

  function syncFromSelectedPlan(fieldset, opts) {
    opts = opts || {};
    var checked = fieldset.querySelector(
      'input.skio-group-input[skio-selling-plan-group]:checked'
    );
    if (!checked) {
      syncFormSubscriptionMode(fieldset);
      return;
    }
    var card = checked.closest(".skio-performance-flat-plan-card");
    if (!card) return;
    var qtyInput = card.querySelector(".skio-performance-flat-qty-input");
    if (!qtyInput) return;
    var form = fieldset.closest("form");
    var formQty = getFormQtyInput(form);
    var min = Number(qtyInput.dataset.minQty);
    if (!Number.isFinite(min) || min < 1) min = 1;

    var q;
    if (opts.preserveFormQuantity && formQty) {
      q = parseInt(String(formQty.value), 10);
      if (!Number.isFinite(q)) q = min;
      if (q < min) q = min;
    } else {
      q = min;
    }

    qtyInput.value = String(q);
    if (formQty) formQty.value = String(q);

    resetInactiveCardQtyInputs(fieldset, checked);
    updateMinusState(qtyInput);
    applyQtyToCardPrice(fieldset, qtyInput);
    syncFormSubscriptionMode(fieldset);
  }

  function initFieldset(fieldset) {
    if (!fieldset.classList.contains("skio-plan-picker--split-layout")) return;
    if (fieldset.dataset.skioFlatQtyInit) return;
    fieldset.dataset.skioFlatQtyInit = "1";

    fieldset.addEventListener("change", function (e) {
      var t = e.target;
      if (!t) return;
      if (t.matches('.skio-performance-flat-qty-input')) {
        var form = fieldset.closest("form");
        var formQty = getFormQtyInput(form);
        var min = Number(t.dataset.minQty);
        if (!Number.isFinite(min) || min < 1) min = 1;
        var v = parseInt(String(t.value), 10);
        if (!Number.isFinite(v)) v = min;
        if (v < min) v = min;
        t.value = String(v);
        if (formQty) formQty.value = String(v);
        updateMinusState(t);
        applyQtyToCardPrice(fieldset, t);
        return;
      }
      if (
        t.matches('input.skio-group-input[type="radio"]') &&
        t.hasAttribute("skio-one-time")
      ) {
        syncFormSubscriptionMode(fieldset);
        return;
      }
      if (t.matches('input.skio-group-input[skio-selling-plan-group]')) {
        /* Use each plan's min as default when switching delivery — do not keep main form qty (e.g. 6) on a monthly card. */
        syncFromSelectedPlan(fieldset, { preserveFormQuantity: false });
      }
    });

    fieldset.addEventListener("skio:flat-plan-prices-updated", function () {
      var checked = fieldset.querySelector(
        'input.skio-group-input[skio-selling-plan-group]:checked'
      );
      if (!checked) return;
      var card = checked.closest(".skio-performance-flat-plan-card");
      var qtyInput = card && card.querySelector(".skio-performance-flat-qty-input");
      if (qtyInput) {
        applyQtyToCardPrice(fieldset, qtyInput);
        updateMinusState(qtyInput);
      }
    });

    fieldset.addEventListener("skio:plan-picker:update", function () {
      if (subscriptionChecked(fieldset)) {
        syncFromSelectedPlan(fieldset, { preserveFormQuantity: true });
      } else {
        syncFormSubscriptionMode(fieldset);
      }
    });

    // Initial pass (Skio may init slightly later)
    requestAnimationFrame(function () {
      if (subscriptionChecked(fieldset)) {
        syncFromSelectedPlan(fieldset, { preserveFormQuantity: false });
      } else {
        syncFormSubscriptionMode(fieldset);
      }
    });
  }

  function scan() {
    document
      .querySelectorAll("fieldset.skio-plan-picker--split-layout[skio-plan-picker]")
      .forEach(initFieldset);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", scan);
  } else {
    scan();
  }

  document.addEventListener("skio:plan-picker:loaded", scan);
})();
